import { GetterTree } from "vuex";
import { RootState } from "../types";
import { UserState } from "./types";

export const getters: GetterTree<UserState, RootState> = {
  isAuthenticated(state: UserState): boolean {
    return !!state.user;
  }
};
